// src/Contacto.tsx
import React, { useState } from 'react';
import AnimationWrapper from './AnimationWrapper';
import { COMPANY_INFO } from './config';

// === COMPONENTES DE ICONOS ===
const IconoInstagram: React.FC = () => <img src="/IntagramLogo.webp" alt="IG" className="w-8 h-8" />;
const IconoTikTok: React.FC = () => <img src="/TikTokLogo.webp" alt="TT" className="w-8 h-8" />;
const IconoFacebook: React.FC = () => <img src="/FacebookLogo.webp" alt="FB" className="w-8 h-8" />;
const IconoMantenimiento: React.FC = () => (<svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.5.305 1.077.5 1.724 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>);

// Función auxiliar para codificar datos para Netlify
const encode = (data: any) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

const Contacto: React.FC = () => {
    const [statusVentas, setStatusVentas] = useState<'idle' | 'success' | 'error'>('idle');
    const [statusTaller, setStatusTaller] = useState<'idle' | 'success' | 'error'>('idle');

    // Manejo del Formulario de Ventas
    const handleContactSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        if (!data.nombre || !data.email || !data.telefono || !data.mensaje) {
            alert("Por favor completa todos los campos requeridos.");
            return;
        }

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "contacto-ventas", ...data })
        })
        .then(() => {
            setStatusVentas('success');
            form.reset();
            setTimeout(() => setStatusVentas('idle'), 5000);
        })
        .catch(error => {
            console.error(error);
            setStatusVentas('error');
        });
    };

    // Manejo del Formulario de Taller
    const handleServiceSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        if (!data.propietario || !data.telefono || !data.modelo || !data.servicio) {
            alert("Por favor completa los datos principales del vehículo.");
            return;
        }

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "contacto-taller", ...data })
        })
        .then(() => {
            setStatusTaller('success');
            form.reset();
            setTimeout(() => setStatusTaller('idle'), 5000);
        })
        .catch(error => {
            console.error(error);
            setStatusTaller('error');
        });
    };

    // === CORRECCIÓN AQUÍ: Agregué 'appearance-none' a ambas variables ===
    const inputLight = "w-full p-4 bg-gray-50 border border-gray-300 text-gray-900 focus:ring-2 focus:ring-yellow-600 focus:border-transparent outline-none transition-all appearance-none";
    const inputDark = "w-full p-4 bg-gray-800 border border-gray-700 text-white placeholder-gray-400 focus:ring-2 focus:ring-yellow-600 focus:border-transparent outline-none transition-all appearance-none";

    return (
        <div className="min-h-screen bg-white font-sans">
            
            {/* === 1. HERO HEADER === */}
            <div className="relative h-[40vh] bg-black flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=2073&auto=format&fit=crop')] bg-cover bg-center opacity-40"></div>
                <div className="relative z-10 text-center px-4">
                    <AnimationWrapper direction="up">
                        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4">
                            Estamos para <span className="text-yellow-500">Ayudarte</span>
                        </h1>
                        <p className="text-xl text-gray-300">
                            Elige el canal de tu preferencia y conversemos.
                        </p>
                    </AnimationWrapper>
                </div>
            </div>

            {/* === 2. ACCESOS RÁPIDOS === */}
            <div className="max-w-7xl mx-auto px-4 -mt-16 relative z-20 mb-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* WhatsApp */}
                    <AnimationWrapper direction="up" delay={0}>
                        <div className="bg-white p-8 shadow-xl border-t-4 border-green-500 text-center hover:-translate-y-2 transition duration-300">
                            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                <img src="/WhatsappLogo.webp" alt="WhatsApp" className="w-9 h-9" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">WhatsApp Directo</h3>
                            <p className="text-gray-500 text-sm mb-4">Respuesta inmediata con un asesor.</p>
                            <a href={`https://wa.me/${COMPANY_INFO.whatsappNumber}`} target="_blank" rel="noreferrer" className="text-green-600 font-bold hover:underline">Chatear ahora →</a>
                        </div>
                    </AnimationWrapper>

                    {/* Redes Sociales */}
                    <AnimationWrapper direction="up" delay={100}>
                        <div className="bg-white p-8 shadow-xl border-t-4 border-yellow-500 text-center hover:-translate-y-2 transition duration-300">
                            <div className="flex justify-center space-x-4 mb-6">
                                <a href={COMPANY_INFO.instagramUrl} target="_blank" rel="noreferrer" className="hover:scale-110 transition"><IconoInstagram/></a>
                                <a href={COMPANY_INFO.tiktokUrl} target="_blank" rel="noreferrer" className="hover:scale-110 transition"><IconoTikTok/></a>
                                <a href={COMPANY_INFO.facebookUrl} target="_blank" rel="noreferrer" className="hover:scale-110 transition"><IconoFacebook/></a>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">Síguenos</h3>
                            <p className="text-gray-500 text-sm">Únete a nuestra comunidad Bestune.</p>
                        </div>
                    </AnimationWrapper>

                    {/* Email */}
                    <AnimationWrapper direction="up" delay={200}>
                        <div className="bg-white p-8 shadow-xl border-t-4 border-red-500 text-center hover:-translate-y-2 transition duration-300">
                            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                                <img src="/CorreoLogo.webp" alt="Email" className="w-9 h-9" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">Correo Electrónico</h3>
                            <p className="text-gray-500 text-sm mb-4">Para cotizaciones formales o corporativas.</p>
                            <a href={`mailto:${COMPANY_INFO.email}`} className="text-red-600 font-bold hover:underline">{COMPANY_INFO.email}</a>
                        </div>
                    </AnimationWrapper>
                </div>
            </div>

            {/* === 3. FORMULARIO 1: CONSULTA GENERAL / VENTAS === */}
            <div className="py-16 bg-gray-50">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <AnimationWrapper direction="left">
                            <div>
                                <h2 className="text-3xl font-extrabold text-gray-900 mb-4">¿Interesado en un Bestune?</h2>
                                <p className="text-lg text-gray-600 mb-6">
                                    Si tienes preguntas sobre precios, financiamiento o características de nuestros modelos, déjanos tus datos.
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-center text-gray-700"><span className="text-yellow-600 mr-2">✓</span> Atención personalizada</li>
                                    <li className="flex items-center text-gray-700"><span className="text-yellow-600 mr-2">✓</span> Planes de financiamiento a medida</li>
                                </ul>
                            </div>
                        </AnimationWrapper>

                        <AnimationWrapper direction="right">
                            <div className="bg-white p-8 shadow-lg border border-gray-100">
                                <h3 className="text-xl font-bold text-gray-800 mb-6 border-b pb-2">Consulta General / Ventas</h3>
                                
                                <form name="contacto-ventas" method="post" onSubmit={handleContactSubmit} className="space-y-4">
                                    <input type="hidden" name="form-name" value="contacto-ventas" />
                                    
                                    <input type="text" name="nombre" placeholder="Nombre y Apellido" required className={inputLight} />
                                    <div className="grid grid-cols-2 gap-4">
                                        <input type="email" name="email" placeholder="Correo" required className={inputLight} />
                                        <input type="tel" name="telefono" placeholder="Teléfono" required className={inputLight} />
                                    </div>
                                    <select name="asunto" defaultValue="" required className={inputLight}>
                                        <option value="" disabled>Motivo de Consulta</option>
                                        <option value="Ventas">Cotización de Vehículo</option>
                                        <option value="Repuestos">Repuestos</option>
                                        <option value="General">Información General</option>
                                    </select>
                                    <textarea name="mensaje" placeholder="¿En qué podemos ayudarte?" rows={4} required className={inputLight}></textarea>
                                    
                                    <button type="submit" disabled={statusVentas === 'success'} className="w-full bg-yellow-600 text-white font-bold py-4 hover:bg-yellow-700 transition duration-200 shadow-md disabled:bg-gray-400">
                                        {statusVentas === 'success' ? '¡Mensaje Enviado!' : statusVentas === 'error' ? 'Error al enviar' : 'Enviar Consulta'}
                                    </button>
                                    {statusVentas === 'success' && <p className="text-green-600 text-center text-sm mt-2">Gracias por contactarnos. Te responderemos pronto.</p>}
                                </form>
                            </div>
                        </AnimationWrapper>
                    </div>
                </div>
            </div>

            {/* === 4. FORMULARIO 2: SERVICIO TÉCNICO === */}
            <div className="py-20 bg-gray-900 text-white relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10"></div>
                <div className="relative z-10 max-w-6xl mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">Centro de Servicio Bestune</h2>
                        <p className="text-gray-400 max-w-2xl mx-auto">Agenda tu cita de mantenimiento con nuestros expertos.</p>
                    </div>

                    <div className="bg-black/50 p-8 md:p-12 border border-gray-800 backdrop-blur-sm max-w-4xl mx-auto shadow-2xl">
                        
                        <form name="contacto-taller" method="post" onSubmit={handleServiceSubmit}>
                            <input type="hidden" name="form-name" value="contacto-taller" />

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                <div className="space-y-4">
                                    <label className="block text-sm font-bold text-yellow-500 uppercase">Datos del Propietario</label>
                                    <input type="text" name="propietario" placeholder="Nombre Completo" required className={inputDark} />
                                    <input type="tel" name="telefono" placeholder="Teléfono de Contacto" required className={inputDark} />
                                    <input type="email" name="email" placeholder="Correo Electrónico" required className={inputDark} />
                                </div>
                                <div className="space-y-4">
                                    <label className="block text-sm font-bold text-yellow-500 uppercase">Datos del Vehículo</label>
                                    <input type="text" name="modelo" placeholder="Modelo (Ej: Bestune T77)" required className={inputDark} />
                                    <input type="number" name="kilometraje" placeholder="Kilometraje Aprox." required className={inputDark} />
                                    
                                    {/* === CORRECCIÓN AQUÍ: Contenedor 'w-full' y classNames ajustados === */}
                                    <div className="relative w-full">
                                        <input 
                                            type="date" 
                                            name="fecha" 
                                            required 
                                            className={`date-input-placeholder ${inputDark} min-h-[58px]`}
                                        />
                                    </div>
                                    {/* ================================================= */}

                                </div>
                            </div>
                            
                            <div className="mb-8">
                                <label className="block text-sm font-bold text-yellow-500 uppercase mb-2">Servicio Requerido</label>
                                <textarea name="servicio" placeholder="Describe el servicio (Mantenimiento preventivo, Revisión de frenos, etc.)" rows={3} required className={inputDark}></textarea>
                            </div>

                            <div className="text-center">
                                <button type="submit" disabled={statusTaller === 'success'} className="bg-white text-black font-bold py-4 px-12 hover:bg-yellow-500 hover:text-white transition duration-300 text-lg shadow-lg flex items-center justify-center mx-auto disabled:bg-gray-400">
                                    <IconoMantenimiento />
                                    {statusTaller === 'success' ? 'Solicitud Enviada' : 'Solicitar Cita de Taller'}
                                </button>
                                {statusTaller === 'success' && <p className="text-green-400 font-bold mt-4 animate-pulse">¡Solicitud recibida! Te contactaremos para confirmar.</p>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* === ESTILOS CSS CORREGIDOS PARA ALINEACIÓN PERFECTA === */}
            <style>{`
                /* El padding-left: 1rem equivale a p-4 de tailwind, asegurando alineación */
                .date-input-placeholder:invalid::-webkit-datetime-edit {
                    color: transparent;
                }
                .date-input-placeholder:invalid::before {
                    content: "Fecha Preferida";
                    color: #9ca3af; /* Gris placeholder standard */
                    position: absolute;
                    left: 1rem; /* Alineado exactamente igual que el input de arriba */
                    top: 50%;
                    transform: translateY(-50%); /* Centrado vertical perfecto */
                    pointer-events: none;
                }
                
                /* Icono de calendario blanco e invertido */
                .date-input-placeholder::-webkit-calendar-picker-indicator {
                    position: absolute;
                    right: 1rem;
                    cursor: pointer;
                    filter: invert(1); 
                }
            `}</style>
        </div>
    );
};

export default Contacto;